const railButtons = document.querySelectorAll("[data-scroll]");

railButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const rail = document.getElementById(button.dataset.scroll);
    const direction = Number(button.dataset.dir || 1);
    if (!rail) return;
    rail.scrollBy({
      left: direction * Math.max(rail.clientWidth * 0.72, 280),
      behavior: "smooth",
    });
  });
});

const giftTabs = document.querySelectorAll(".tabs button");

giftTabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    giftTabs.forEach((item) => {
      item.classList.toggle("active", item === tab);
      item.setAttribute("aria-selected", String(item === tab));
    });
  });
});

const categoryButtons = document.querySelectorAll(".food-categories button");
const quickProducts = document.querySelectorAll(".quick-product");

categoryButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const selectedCategory = button.dataset.category;

    categoryButtons.forEach((item) => item.classList.toggle("active", item === button));
    quickProducts.forEach((product) => {
      const categories = product.dataset.category || "";
      product.classList.toggle("is-hidden", selectedCategory !== "all" && !categories.includes(selectedCategory));
    });
  });
});

document.querySelectorAll(".quick-add").forEach((button) => {
  button.addEventListener("click", () => {
    if (button.closest(".kr-add-form[data-collection-quick-add='true']")) return;
    const current = Number(button.dataset.qty || 0) + 1;
    button.dataset.qty = String(current);
    button.textContent = current > 1 ? String(current) : "1";
    button.setAttribute("aria-label", `Quantity ${current}`);
  });
});

document.querySelectorAll(".shopify-product > button").forEach((button) => {
  button.addEventListener("click", () => {
    button.textContent = "Added";
    button.classList.add("is-added");
  });
});

document.querySelectorAll(".kuuraii-proto .product-gallery").forEach((gallery) => {
  const mainImage = gallery.querySelector(".product-main-image");
  const mobileGallery = gallery.querySelector(".product-mobile-media");

  const mobileSlides = Array.from(
    gallery.querySelectorAll(".product-mobile-media__slide")
  );

  const thumbnailButtons = Array.from(
    gallery.querySelectorAll(".product-thumbs button[data-image]")
  );

  if (!thumbnailButtons.length) return;

  function setMainImageMode(mode) {
    if (!mainImage) return;

    mainImage.dataset.mediaMode = mode === "document" ? "document" : "photo";
  }

  function setActiveThumbnail(activeIndex) {
    thumbnailButtons.forEach((button, index) => {
      const isActive = index === activeIndex;

      button.classList.toggle("active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function scrollMobileGalleryToSlide(index) {
    if (!mobileGallery || !mobileSlides[index]) return;

    const slide = mobileSlides[index];
    const galleryRect = mobileGallery.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();

    const targetLeft =
      mobileGallery.scrollLeft +
      slideRect.left -
      galleryRect.left;

    mobileGallery.scrollTo({
      left: targetLeft,
      behavior: "smooth",
    });
  }

  function updateMainImage(index) {
    const button = thumbnailButtons[index];
    if (!button) return;
    const thumbnailImage = button.querySelector("img");
    const fullImage = button.dataset.image || thumbnailImage?.src;
    const imageAlt = button.dataset.imageAlt || thumbnailImage?.alt;
    setActiveThumbnail(index);
    setMainImageMode(button.dataset.mediaMode);
    // Clear the previous responsive source when selecting another image.
    if (mainImage && fullImage && mainImage.getAttribute("src") !== fullImage) {
      mainImage.removeAttribute("srcset");
      mainImage.removeAttribute("sizes");
      mainImage.src = fullImage;
      if (imageAlt) mainImage.alt = imageAlt;
    }
  }

  thumbnailButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      updateMainImage(index);
      if (window.matchMedia("(max-width: 749px)").matches) {
        scrollMobileGalleryToSlide(index);
      }
    });
  });

  /*
   * Update the highlighted thumbnail when the customer
   * manually swipes the mobile image gallery.
   */
  if (mobileGallery && mobileSlides.length) {
    let scrollFrame;

    mobileGallery.addEventListener(
      "scroll",
      () => {
        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = requestAnimationFrame(() => {
          const galleryRect = mobileGallery.getBoundingClientRect();
          const galleryCenter =
            galleryRect.left + galleryRect.width / 2;

          let nearestIndex = 0;
          let nearestDistance = Infinity;

          mobileSlides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const slideCenter =
              slideRect.left + slideRect.width / 2;

            const distance = Math.abs(
              galleryCenter - slideCenter
            );

            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          if (nearestIndex < thumbnailButtons.length) {
            updateMainImage(nearestIndex);
          }
        });
      },
      { passive: true }
    );
  }

  const initialActiveIndex = thumbnailButtons.findIndex((button) =>
    button.classList.contains("active")
  );
  setMainImageMode(thumbnailButtons[Math.max(initialActiveIndex, 0)]?.dataset.mediaMode);
  if (gallery.closest('.kuuraii-proto--bedding-product') && thumbnailButtons.length > 1) {
    gallery.dataset.swipeGallery = 'true';
    const mainFrame = gallery.querySelector('.product-main-image-wrap');
    const activeIndex = () => Math.max(0, thumbnailButtons.findIndex(button => button.classList.contains('active')));
    const chooseImage = index => thumbnailButtons[Math.max(0, Math.min(index, thumbnailButtons.length - 1))].click();

    function bindSwipe(surface, nativeTouch) {
      if (!surface) return;
      let gesture = null;
      surface.querySelectorAll('img').forEach(img => { img.draggable = false; });
      surface.addEventListener('dragstart', event => event.preventDefault());
      surface.addEventListener('pointerdown', event => {
        // Phones use the native scrolling rail, including momentum and pinch zoom.
        if (!event.isPrimary || event.button !== 0 || (nativeTouch && event.pointerType !== 'mouse')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, index: activeIndex() };
        surface.setPointerCapture(event.pointerId);
      });
      surface.addEventListener('pointermove', event => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          surface.classList.add('is-dragging');
        }
      });
      function finishGesture(event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        const previous = gesture;
        gesture = null;
        surface.classList.remove('is-dragging');
        if (surface.hasPointerCapture(event.pointerId)) surface.releasePointerCapture(event.pointerId);
        const dx = event.clientX - previous.x;
        const dy = event.clientY - previous.y;
        if (event.type === 'pointerup' && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          chooseImage(previous.index + (dx < 0 ? 1 : -1));
        }
      }
      surface.addEventListener('pointerup', finishGesture);
      surface.addEventListener('pointercancel', finishGesture);
      surface.addEventListener('lostpointercapture', () => {
        gesture = null;
        surface.classList.remove('is-dragging');
      });
      surface.tabIndex = 0;
      surface.setAttribute('role', 'group');
      surface.setAttribute('aria-label', 'Product images. Swipe or use left and right arrow keys to browse.');
      surface.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        chooseImage(activeIndex() + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }
    bindSwipe(mainFrame, false);
    bindSwipe(mobileGallery, true);
  }

});

document.querySelectorAll(".variant-row button").forEach((button) => {
  button.addEventListener("click", () => {
    const group = button.closest(".variant-row");
    group?.querySelectorAll("button").forEach((item) => item.classList.toggle("active", item === button));

    const root = button.closest("[data-product-root]");
    const variantInput = root?.querySelector("[data-variant-input]");
    const priceNode = root?.querySelector("[data-product-price]");
    const compareNode = root?.querySelector("[data-product-compare-price]");
    const badgeNode = root?.querySelector("[data-product-badge]");
    const addToCart = root?.querySelector("[data-add-to-cart]");
    const preorderProperty = root?.querySelector("[data-preorder-property]");
    const selectedSizeDetail = root?.querySelector("[data-selected-size-detail]");
    const selectedBedSize = root?.querySelector("[data-selected-bed-size]");
    const selectedStockStatus = root?.querySelector("[data-selected-stock-status]");

    if (variantInput && button.dataset.variantId) {
      variantInput.value = button.dataset.variantId;
    }
    if (priceNode && button.dataset.variantPrice) {
      priceNode.innerHTML = button.dataset.variantPrice;
    }
    if (compareNode) {
      compareNode.innerHTML = button.dataset.variantCompare || "";
    }
    if (badgeNode) {
      const nextBadge = button.dataset.variantBadge || "";
      badgeNode.textContent = nextBadge;
      badgeNode.hidden = !nextBadge;
    }
    if (addToCart) {
      const available = button.dataset.variantAvailable !== "false";
      const preorder = button.dataset.variantPreorder === "true";
      addToCart.disabled = !available && !preorder;
      addToCart.textContent = preorder ? "Pre-order now" : available ? "Add to cart" : "Sold out";
      if (preorderProperty) {
        preorderProperty.disabled = !preorder;
      }
    }
    if (selectedSizeDetail) selectedSizeDetail.textContent = button.dataset.variantDetail || "";
    if (selectedBedSize && button.dataset.variantBedSize) selectedBedSize.textContent = button.dataset.variantBedSize;
    if (selectedStockStatus) {
      const available = button.dataset.variantAvailable !== "false";
      const preorder = button.dataset.variantPreorder === "true";
      selectedStockStatus.textContent = preorder ? "Pre-order" : available ? "Ready to ship" : "Sold out";
    }

    // Sync main image and gallery for the selected variant
    const productScope = button.closest(".kuuraii-proto") || button.closest(".product-hero") || document;
    const gallery = productScope.querySelector(".product-gallery, .millet-pdp__gallery, [data-product-mobile-gallery]");
    if (gallery) {
      const mediaId = button.dataset.mediaId || button.dataset.variantMediaId;
      const variantImage = button.dataset.variantImage;
      const variantImageAlt = button.dataset.variantImageAlt || "";
      const thumbs = Array.from(gallery.querySelectorAll(".product-thumbs button[data-image], .millet-pdp__thumbs button[data-image], [data-gallery-thumb]"));
      const mainImage = gallery.querySelector(".product-main-image, .millet-pdp__main-image");
      const mobileGallery = gallery.querySelector("[data-product-mobile-gallery], .product-mobile-media");
      const mobileSlides = Array.from(gallery.querySelectorAll(".product-mobile-media__slide, .toda-pdp__media-slide"));

      let matchedThumb = null;
      if (mediaId && thumbs.length) {
        matchedThumb = thumbs.find((t) => t.dataset.mediaId === mediaId);
      }
      if (!matchedThumb && variantImage && thumbs.length) {
        const cleanVariantFilename = variantImage.split("?")[0].split("/").pop().toLowerCase();
        if (cleanVariantFilename) {
          matchedThumb = thumbs.find((t) => {
            const thumbSrc = (t.dataset.image || t.querySelector("img")?.src || "").split("?")[0].split("/").pop().toLowerCase();
            return thumbSrc && (thumbSrc === cleanVariantFilename || thumbSrc.includes(cleanVariantFilename) || cleanVariantFilename.includes(thumbSrc));
          });
        }
      }

      if (matchedThumb) {
        matchedThumb.click();
      } else {
        if (mainImage && variantImage) {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = variantImage;
          if (variantImageAlt) {
            mainImage.alt = variantImageAlt;
          }
        }
        if (mobileGallery && mobileSlides.length) {
          let slideIndex = -1;
          if (mediaId) {
            slideIndex = mobileSlides.findIndex((s) => s.dataset.mediaId === mediaId);
          }
          if (slideIndex === -1 && variantImage) {
            const cleanVariantFilename = variantImage.split("?")[0].split("/").pop().toLowerCase();
            if (cleanVariantFilename) {
              slideIndex = mobileSlides.findIndex((s) => {
                const slideSrc = (s.querySelector("img")?.src || "").split("?")[0].split("/").pop().toLowerCase();
                return slideSrc && (slideSrc === cleanVariantFilename || slideSrc.includes(cleanVariantFilename));
              });
            }
          }
          if (slideIndex > -1) {
            const slide = mobileSlides[slideIndex];
            const galleryRect = mobileGallery.getBoundingClientRect();
            const slideRect = slide.getBoundingClientRect();
            const targetLeft = mobileGallery.scrollLeft + slideRect.left - galleryRect.left;
            mobileGallery.scrollTo({ left: targetLeft, behavior: "smooth" });
          }
        }
      }
    }
  });
});

// Sync gallery with initially active variant on page load
const initialActiveVariant = document.querySelector(".variant-row button.active, .variant-row button.is-active");
if (initialActiveVariant && (initialActiveVariant.dataset.mediaId || initialActiveVariant.dataset.variantImage)) {
  const initialScope = initialActiveVariant.closest(".kuuraii-proto") || initialActiveVariant.closest(".product-hero") || document;
  const initialGallery = initialScope.querySelector(".product-gallery, .millet-pdp__gallery");
  if (initialGallery) {
    const initMediaId = initialActiveVariant.dataset.mediaId;
    const initImage = initialActiveVariant.dataset.variantImage;
    const thumbs = Array.from(initialGallery.querySelectorAll(".product-thumbs button[data-image], .millet-pdp__thumbs button[data-image]"));
    let initThumb = null;
    if (initMediaId && thumbs.length) {
      initThumb = thumbs.find((t) => t.dataset.mediaId === initMediaId);
    }
    if (!initThumb && initImage && thumbs.length) {
      const cleanInitFilename = initImage.split("?")[0].split("/").pop().toLowerCase();
      if (cleanInitFilename) {
        initThumb = thumbs.find((t) => {
          const thumbSrc = (t.dataset.image || t.querySelector("img")?.src || "").split("?")[0].split("/").pop().toLowerCase();
          return thumbSrc && (thumbSrc === cleanInitFilename || thumbSrc.includes(cleanInitFilename) || cleanInitFilename.includes(thumbSrc));
        });
      }
    }
    if (initThumb && !initThumb.classList.contains("active") && !initThumb.classList.contains("is-active")) {
      initThumb.click();
    }
  }
}

document.querySelectorAll(".add-cart, .buy-now, .mobile-purchase-bar button").forEach((button) => {
  button.addEventListener("click", () => {
    button.textContent = button.classList.contains("buy-now") ? "Checking out" : "Added";
  });
});

function initPdpDiscountTickers() {
  document.querySelectorAll("[data-pdp-discount-ticker]").forEach(function(ticker) {
    if (ticker.dataset.tickerReady) return;
    ticker.dataset.tickerReady = "true";
    var items = Array.from(ticker.querySelectorAll(".pdp-discount-ticker__item"));
    if (items.length < 2) return;
    var activeIndex = 0;
    setInterval(function() {
      if (document.hidden) return;
      items[activeIndex].classList.remove("is-active");
      activeIndex = (activeIndex + 1) % items.length;
      items[activeIndex].classList.add("is-active");
    }, 2000);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdpDiscountTickers);
} else {
  initPdpDiscountTickers();
}

